const Raptor = Mach.requireModule('Raptor')
const SLRaptor = Mach.requireModule('SLRaptor')
const SLCompass = Mach.requireModule('SLCompass')
const compassInfo = SLCompass ? (SLCompass?.getCompassInfo ? SLCompass?.getCompassInfo?.() : { region: 'HK', cityId: '' }) : { region: 'HK', cityId: '' }

const defaultTags = {
  uuid: Mach.env.uuid ?? '', // 用户设备ID
  osName: Mach.env.osName ?? '', // 系统名称
  osVersion: Mach.env.osVersion ?? '', // 系统版本
  deviceModel: Mach.env.deviceModel ?? '', // 机型
  appVersion: Mach.env.version ?? '', // APP版本号
  appName: Mach.env.appName ?? '', // APP名称
  bundleName: Mach.env.bundleName ?? '', // Bundle 名称（主包）
  bundleVersion: Mach.env.bundleVersion ?? '', // Bundle 版本（主包）
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
  env: Mach.env.isDebug ? 'Test' : 'Prod', // 环境
  slEnv: Mach.env.isDebug ? 'Test' : 'Prod',
  slAppVer: Mach.env.version ?? '',
  slPlatform: Mach.env.isAndroid ? 'Android' : 'iOS',
}

const commonTags = {
  region: compassInfo?.region,
  cityId: compassInfo?.cityId,
}

/**
 * 检查Value类型是否为字符串并转换
 * @param obj
 * @returns
 */
function checkAndConvertToString (obj: { [key: string]: string | number }) {
  if (Array.isArray(obj) || typeof obj !== 'object') {
    return obj
  }
  const convertObj = {} as { [key: string]: string | number }
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === 'string') {
        convertObj[key] = obj[key]
      } else if (typeof obj[key] === 'number') {
        convertObj[key] = String(obj[key])
      }
    }
  }
  return convertObj
}

/**
 * 上报Report监控指标
 * @param params
 * @param tags
 */
function reportMetrics (params: { [key: string]: number }, tags?: { [key: string]: string | number }, sampleRate?: number) {
  const tagsObj = { ...defaultTags, ...commonTags, ...(tags || {}) }
  // 校验tag数据是否为字符串
  const tagParams = checkAndConvertToString(tagsObj)
  Raptor?.reportMetrics?.(params, tagParams, sampleRate || 1.0)
}

export function reportRaptorMetrics (params: { [key: string]: number }, tags?: { [key: string]: string | number }, sampleRate?: number) {
  if (SLRaptor) {
    const tagsObj = { ...defaultTags, ...commonTags, ...(tags || {}) }
    // 校验tag数据是否为字符串
    const tagParams = checkAndConvertToString(tagsObj)
    SLRaptor?.reportMetrics?.(params, tagParams, sampleRate || 1.0)
  } else {
    reportMetrics(params, tags, sampleRate)
  }
}
